.widget-grid {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  cursor: default;

  @media screen and (min-width: $bp-medium) {
    gap: 1.6rem;
  }
}

.middle-widget-container {
  min-width: 0;

  @media screen and (min-width: $bp-medium) {
    padding: 0 1.6rem;
  }
}

.grid-row-wrapper {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 0.8rem;

  &:first-child {
    grid-auto-rows: 1fr;
  }

  @media screen and (max-width: #{$bp-medium + 1}) {
    &:first-child {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }

  @media screen and (min-width: $bp-medium) {
    grid-gap: unset;
    grid-template-columns: 33% 34% 33%;

    &:last-child {
      grid-auto-rows: 1fr;
    }
  }
}
